export default __webpack_public_path__ + "assets/images/9f03bb8371fc1392542e667c75f8da75.svg";